/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthAuthIndexRouteImport } from './routes/_auth/auth/index'
import { Route as AppTeamIndexRouteImport } from './routes/_app/team/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppPlansIndexRouteImport } from './routes/_app/plans/index'
import { Route as AppGuidesIndexRouteImport } from './routes/_app/guides/index'
import { Route as AppCollectionsIndexRouteImport } from './routes/_app/collections/index'
import { Route as AuthAuthVerifyRouteImport } from './routes/_auth/auth/verify'
import { Route as AuthAuthSignupRouteImport } from './routes/_auth/auth/signup'
import { Route as AuthAuthSigninRouteImport } from './routes/_auth/auth/signin'
import { Route as AuthAuthLoginInfostartRouteImport } from './routes/_auth/auth/login-infostart'
import { Route as AuthAuthLoginRouteImport } from './routes/_auth/auth/login'
import { Route as AuthAuthInviteRouteImport } from './routes/_auth/auth/invite'
import { Route as AuthAuthInstallExtRouteImport } from './routes/_auth/auth/install-ext'
import { Route as AuthAuthCallbackRouteImport } from './routes/_auth/auth/callback'
import { Route as AuthAuthAppRouteImport } from './routes/_auth/auth/app'
import { Route as AppGuidesExtensionRouteImport } from './routes/_app/guides/extension'
import { Route as AppGuidesCreateRouteImport } from './routes/_app/guides/create'
import { Route as AppAgentsWindowsRouteImport } from './routes/_app/agents/windows'
import { Route as AppAgentsMobileRouteImport } from './routes/_app/agents/mobile'
import { Route as AppAgentsExtensionRouteImport } from './routes/_app/agents/extension'
import { Route as AppGuidesGuideIdIndexRouteImport } from './routes/_app/guides/$guideId.index'
import { Route as AppCollectionsCollectionIdIndexRouteImport } from './routes/_app/collections/$collectionId.index'
import { Route as AppGuidesGuideIdEditRouteImport } from './routes/_app/guides/$guideId.edit'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthAuthIndexRoute = AuthAuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => AuthRoute,
} as any)
const AppTeamIndexRoute = AppTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlansIndexRoute = AppPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AppRoute,
} as any)
const AppGuidesIndexRoute = AppGuidesIndexRouteImport.update({
  id: '/guides/',
  path: '/guides/',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionsIndexRoute = AppCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => AppRoute,
} as any)
const AuthAuthVerifyRoute = AuthAuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthSignupRoute = AuthAuthSignupRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthSigninRoute = AuthAuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthLoginInfostartRoute = AuthAuthLoginInfostartRouteImport.update({
  id: '/auth/login-infostart',
  path: '/auth/login-infostart',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthLoginRoute = AuthAuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthInviteRoute = AuthAuthInviteRouteImport.update({
  id: '/auth/invite',
  path: '/auth/invite',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthInstallExtRoute = AuthAuthInstallExtRouteImport.update({
  id: '/auth/install-ext',
  path: '/auth/install-ext',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthCallbackRoute = AuthAuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthAppRoute = AuthAuthAppRouteImport.update({
  id: '/auth/app',
  path: '/auth/app',
  getParentRoute: () => AuthRoute,
} as any)
const AppGuidesExtensionRoute = AppGuidesExtensionRouteImport.update({
  id: '/guides/extension',
  path: '/guides/extension',
  getParentRoute: () => AppRoute,
} as any)
const AppGuidesCreateRoute = AppGuidesCreateRouteImport.update({
  id: '/guides/create',
  path: '/guides/create',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsWindowsRoute = AppAgentsWindowsRouteImport.update({
  id: '/agents/windows',
  path: '/agents/windows',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsMobileRoute = AppAgentsMobileRouteImport.update({
  id: '/agents/mobile',
  path: '/agents/mobile',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsExtensionRoute = AppAgentsExtensionRouteImport.update({
  id: '/agents/extension',
  path: '/agents/extension',
  getParentRoute: () => AppRoute,
} as any)
const AppGuidesGuideIdIndexRoute = AppGuidesGuideIdIndexRouteImport.update({
  id: '/guides/$guideId/',
  path: '/guides/$guideId/',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionsCollectionIdIndexRoute =
  AppCollectionsCollectionIdIndexRouteImport.update({
    id: '/collections/$collectionId/',
    path: '/collections/$collectionId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGuidesGuideIdEditRoute = AppGuidesGuideIdEditRouteImport.update({
  id: '/guides/$guideId/edit',
  path: '/guides/$guideId/edit',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/agents/extension': typeof AppAgentsExtensionRoute
  '/agents/mobile': typeof AppAgentsMobileRoute
  '/agents/windows': typeof AppAgentsWindowsRoute
  '/guides/create': typeof AppGuidesCreateRoute
  '/guides/extension': typeof AppGuidesExtensionRoute
  '/auth/app': typeof AuthAuthAppRoute
  '/auth/callback': typeof AuthAuthCallbackRoute
  '/auth/install-ext': typeof AuthAuthInstallExtRoute
  '/auth/invite': typeof AuthAuthInviteRoute
  '/auth/login': typeof AuthAuthLoginRoute
  '/auth/login-infostart': typeof AuthAuthLoginInfostartRoute
  '/auth/signin': typeof AuthAuthSigninRoute
  '/auth/signup': typeof AuthAuthSignupRoute
  '/auth/verify': typeof AuthAuthVerifyRoute
  '/collections/': typeof AppCollectionsIndexRoute
  '/guides/': typeof AppGuidesIndexRoute
  '/plans/': typeof AppPlansIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/team/': typeof AppTeamIndexRoute
  '/auth/': typeof AuthAuthIndexRoute
  '/guides/$guideId/edit': typeof AppGuidesGuideIdEditRoute
  '/collections/$collectionId/': typeof AppCollectionsCollectionIdIndexRoute
  '/guides/$guideId/': typeof AppGuidesGuideIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/agents/extension': typeof AppAgentsExtensionRoute
  '/agents/mobile': typeof AppAgentsMobileRoute
  '/agents/windows': typeof AppAgentsWindowsRoute
  '/guides/create': typeof AppGuidesCreateRoute
  '/guides/extension': typeof AppGuidesExtensionRoute
  '/auth/app': typeof AuthAuthAppRoute
  '/auth/callback': typeof AuthAuthCallbackRoute
  '/auth/install-ext': typeof AuthAuthInstallExtRoute
  '/auth/invite': typeof AuthAuthInviteRoute
  '/auth/login': typeof AuthAuthLoginRoute
  '/auth/login-infostart': typeof AuthAuthLoginInfostartRoute
  '/auth/signin': typeof AuthAuthSigninRoute
  '/auth/signup': typeof AuthAuthSignupRoute
  '/auth/verify': typeof AuthAuthVerifyRoute
  '/collections': typeof AppCollectionsIndexRoute
  '/guides': typeof AppGuidesIndexRoute
  '/plans': typeof AppPlansIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/team': typeof AppTeamIndexRoute
  '/auth': typeof AuthAuthIndexRoute
  '/guides/$guideId/edit': typeof AppGuidesGuideIdEditRoute
  '/collections/$collectionId': typeof AppCollectionsCollectionIdIndexRoute
  '/guides/$guideId': typeof AppGuidesGuideIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/agents/extension': typeof AppAgentsExtensionRoute
  '/_app/agents/mobile': typeof AppAgentsMobileRoute
  '/_app/agents/windows': typeof AppAgentsWindowsRoute
  '/_app/guides/create': typeof AppGuidesCreateRoute
  '/_app/guides/extension': typeof AppGuidesExtensionRoute
  '/_auth/auth/app': typeof AuthAuthAppRoute
  '/_auth/auth/callback': typeof AuthAuthCallbackRoute
  '/_auth/auth/install-ext': typeof AuthAuthInstallExtRoute
  '/_auth/auth/invite': typeof AuthAuthInviteRoute
  '/_auth/auth/login': typeof AuthAuthLoginRoute
  '/_auth/auth/login-infostart': typeof AuthAuthLoginInfostartRoute
  '/_auth/auth/signin': typeof AuthAuthSigninRoute
  '/_auth/auth/signup': typeof AuthAuthSignupRoute
  '/_auth/auth/verify': typeof AuthAuthVerifyRoute
  '/_app/collections/': typeof AppCollectionsIndexRoute
  '/_app/guides/': typeof AppGuidesIndexRoute
  '/_app/plans/': typeof AppPlansIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/team/': typeof AppTeamIndexRoute
  '/_auth/auth/': typeof AuthAuthIndexRoute
  '/_app/guides/$guideId/edit': typeof AppGuidesGuideIdEditRoute
  '/_app/collections/$collectionId/': typeof AppCollectionsCollectionIdIndexRoute
  '/_app/guides/$guideId/': typeof AppGuidesGuideIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agents/extension'
    | '/agents/mobile'
    | '/agents/windows'
    | '/guides/create'
    | '/guides/extension'
    | '/auth/app'
    | '/auth/callback'
    | '/auth/install-ext'
    | '/auth/invite'
    | '/auth/login'
    | '/auth/login-infostart'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify'
    | '/collections/'
    | '/guides/'
    | '/plans/'
    | '/settings/'
    | '/team/'
    | '/auth/'
    | '/guides/$guideId/edit'
    | '/collections/$collectionId/'
    | '/guides/$guideId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agents/extension'
    | '/agents/mobile'
    | '/agents/windows'
    | '/guides/create'
    | '/guides/extension'
    | '/auth/app'
    | '/auth/callback'
    | '/auth/install-ext'
    | '/auth/invite'
    | '/auth/login'
    | '/auth/login-infostart'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify'
    | '/collections'
    | '/guides'
    | '/plans'
    | '/settings'
    | '/team'
    | '/auth'
    | '/guides/$guideId/edit'
    | '/collections/$collectionId'
    | '/guides/$guideId'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_app/'
    | '/_app/agents/extension'
    | '/_app/agents/mobile'
    | '/_app/agents/windows'
    | '/_app/guides/create'
    | '/_app/guides/extension'
    | '/_auth/auth/app'
    | '/_auth/auth/callback'
    | '/_auth/auth/install-ext'
    | '/_auth/auth/invite'
    | '/_auth/auth/login'
    | '/_auth/auth/login-infostart'
    | '/_auth/auth/signin'
    | '/_auth/auth/signup'
    | '/_auth/auth/verify'
    | '/_app/collections/'
    | '/_app/guides/'
    | '/_app/plans/'
    | '/_app/settings/'
    | '/_app/team/'
    | '/_auth/auth/'
    | '/_app/guides/$guideId/edit'
    | '/_app/collections/$collectionId/'
    | '/_app/guides/$guideId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/auth/': {
      id: '/_auth/auth/'
      path: '/auth'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthAuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/team/': {
      id: '/_app/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof AppTeamIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plans/': {
      id: '/_app/plans/'
      path: '/plans'
      fullPath: '/plans/'
      preLoaderRoute: typeof AppPlansIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/guides/': {
      id: '/_app/guides/'
      path: '/guides'
      fullPath: '/guides/'
      preLoaderRoute: typeof AppGuidesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collections/': {
      id: '/_app/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof AppCollectionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/auth/verify': {
      id: '/_auth/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthAuthVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/signup': {
      id: '/_auth/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthAuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/signin': {
      id: '/_auth/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthAuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/login-infostart': {
      id: '/_auth/auth/login-infostart'
      path: '/auth/login-infostart'
      fullPath: '/auth/login-infostart'
      preLoaderRoute: typeof AuthAuthLoginInfostartRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/login': {
      id: '/_auth/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthAuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/invite': {
      id: '/_auth/auth/invite'
      path: '/auth/invite'
      fullPath: '/auth/invite'
      preLoaderRoute: typeof AuthAuthInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/install-ext': {
      id: '/_auth/auth/install-ext'
      path: '/auth/install-ext'
      fullPath: '/auth/install-ext'
      preLoaderRoute: typeof AuthAuthInstallExtRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/callback': {
      id: '/_auth/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthAuthCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth/app': {
      id: '/_auth/auth/app'
      path: '/auth/app'
      fullPath: '/auth/app'
      preLoaderRoute: typeof AuthAuthAppRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/guides/extension': {
      id: '/_app/guides/extension'
      path: '/guides/extension'
      fullPath: '/guides/extension'
      preLoaderRoute: typeof AppGuidesExtensionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/guides/create': {
      id: '/_app/guides/create'
      path: '/guides/create'
      fullPath: '/guides/create'
      preLoaderRoute: typeof AppGuidesCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/windows': {
      id: '/_app/agents/windows'
      path: '/agents/windows'
      fullPath: '/agents/windows'
      preLoaderRoute: typeof AppAgentsWindowsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/mobile': {
      id: '/_app/agents/mobile'
      path: '/agents/mobile'
      fullPath: '/agents/mobile'
      preLoaderRoute: typeof AppAgentsMobileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/extension': {
      id: '/_app/agents/extension'
      path: '/agents/extension'
      fullPath: '/agents/extension'
      preLoaderRoute: typeof AppAgentsExtensionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/guides/$guideId/': {
      id: '/_app/guides/$guideId/'
      path: '/guides/$guideId'
      fullPath: '/guides/$guideId/'
      preLoaderRoute: typeof AppGuidesGuideIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collections/$collectionId/': {
      id: '/_app/collections/$collectionId/'
      path: '/collections/$collectionId'
      fullPath: '/collections/$collectionId/'
      preLoaderRoute: typeof AppCollectionsCollectionIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/guides/$guideId/edit': {
      id: '/_app/guides/$guideId/edit'
      path: '/guides/$guideId/edit'
      fullPath: '/guides/$guideId/edit'
      preLoaderRoute: typeof AppGuidesGuideIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppAgentsExtensionRoute: typeof AppAgentsExtensionRoute
  AppAgentsMobileRoute: typeof AppAgentsMobileRoute
  AppAgentsWindowsRoute: typeof AppAgentsWindowsRoute
  AppGuidesCreateRoute: typeof AppGuidesCreateRoute
  AppGuidesExtensionRoute: typeof AppGuidesExtensionRoute
  AppCollectionsIndexRoute: typeof AppCollectionsIndexRoute
  AppGuidesIndexRoute: typeof AppGuidesIndexRoute
  AppPlansIndexRoute: typeof AppPlansIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppTeamIndexRoute: typeof AppTeamIndexRoute
  AppGuidesGuideIdEditRoute: typeof AppGuidesGuideIdEditRoute
  AppCollectionsCollectionIdIndexRoute: typeof AppCollectionsCollectionIdIndexRoute
  AppGuidesGuideIdIndexRoute: typeof AppGuidesGuideIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppAgentsExtensionRoute: AppAgentsExtensionRoute,
  AppAgentsMobileRoute: AppAgentsMobileRoute,
  AppAgentsWindowsRoute: AppAgentsWindowsRoute,
  AppGuidesCreateRoute: AppGuidesCreateRoute,
  AppGuidesExtensionRoute: AppGuidesExtensionRoute,
  AppCollectionsIndexRoute: AppCollectionsIndexRoute,
  AppGuidesIndexRoute: AppGuidesIndexRoute,
  AppPlansIndexRoute: AppPlansIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppTeamIndexRoute: AppTeamIndexRoute,
  AppGuidesGuideIdEditRoute: AppGuidesGuideIdEditRoute,
  AppCollectionsCollectionIdIndexRoute: AppCollectionsCollectionIdIndexRoute,
  AppGuidesGuideIdIndexRoute: AppGuidesGuideIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthAuthAppRoute: typeof AuthAuthAppRoute
  AuthAuthCallbackRoute: typeof AuthAuthCallbackRoute
  AuthAuthInstallExtRoute: typeof AuthAuthInstallExtRoute
  AuthAuthInviteRoute: typeof AuthAuthInviteRoute
  AuthAuthLoginRoute: typeof AuthAuthLoginRoute
  AuthAuthLoginInfostartRoute: typeof AuthAuthLoginInfostartRoute
  AuthAuthSigninRoute: typeof AuthAuthSigninRoute
  AuthAuthSignupRoute: typeof AuthAuthSignupRoute
  AuthAuthVerifyRoute: typeof AuthAuthVerifyRoute
  AuthAuthIndexRoute: typeof AuthAuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthAppRoute: AuthAuthAppRoute,
  AuthAuthCallbackRoute: AuthAuthCallbackRoute,
  AuthAuthInstallExtRoute: AuthAuthInstallExtRoute,
  AuthAuthInviteRoute: AuthAuthInviteRoute,
  AuthAuthLoginRoute: AuthAuthLoginRoute,
  AuthAuthLoginInfostartRoute: AuthAuthLoginInfostartRoute,
  AuthAuthSigninRoute: AuthAuthSigninRoute,
  AuthAuthSignupRoute: AuthAuthSignupRoute,
  AuthAuthVerifyRoute: AuthAuthVerifyRoute,
  AuthAuthIndexRoute: AuthAuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
